module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('ul', {
    staticClass: "ui-list"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.name),
      expression: "resumeInfo.name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.resumeInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('div', {
    staticClass: "basic-sex"
  }, [_c('ul', {
    staticClass: "ui-row-flex"
  }, _vm._l((_vm.sexs), function(sex, index) {
    return _c('li', {
      key: sex,
      staticClass: "ui-col ui-col sexbtn",
      class: {
        clicked: index === _vm.activeIndex
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_vm._v(_vm._s(sex))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("婚姻状况：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.marriage),
      expression: "resumeInfo.marriage"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.resumeInfo.marriage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "marriage", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "exprence"
  }, [_c('ul', {
    staticClass: "ui-list"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("工作年限：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.years),
      expression: "resumeInfo.years"
    }],
    staticStyle: {
      "width": "1.45em"
    },
    attrs: {
      "type": "tel",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.resumeInfo.years)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "years", $event.target.value)
      }
    }
  }), _vm._v("年\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("所在公司：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.company),
      expression: "resumeInfo.company"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.resumeInfo.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("担任职务：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.position),
      expression: "resumeInfo.position"
    }],
    attrs: {
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.resumeInfo.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "position", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "school"
  }, [_c('ul', {
    staticClass: "ui-list"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("毕业学校：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.school),
      expression: "resumeInfo.school"
    }],
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.resumeInfo.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "school", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("所学专业：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.major),
      expression: "resumeInfo.major"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.resumeInfo.major)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "major", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("学历：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.education),
      expression: "resumeInfo.education"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.resumeInfo.education)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "education", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('ul', {
    staticClass: "ui-list"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.tel),
      expression: "resumeInfo.tel"
    }],
    attrs: {
      "type": "tel",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.resumeInfo.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "tel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "basic-title"
  }, [_vm._v("电子邮箱：")]), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resumeInfo.email),
      expression: "resumeInfo.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.resumeInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resumeInfo, "email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("请将详细简历发送至该公司邮箱：" + _vm._s(_vm.companyEmail))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("投递简历")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1816aa7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resume.vue
// module id = 223
// module chunks = 1